module.exports = __webpack_public_path__ + "img/array cardio.789b77ab.jpeg";